module.exports = __WEBPACK_EXTERNAL_MODULE_61__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 61
// module chunks = 0